import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CardsSection />
        <FAQSection />
        <IndexSection />
        <CarouselSection />
        <UpdatesSection />
        <TopicsSection />
        <AppSection />
        <CommentsSection />
        <MediaSection />
        <AboutSection />
        <FeaturesSection />
        <ContactSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}